export function generateLoginToken(email: string): string {
  return btoa(email)
    .replace(/=/g, '')
    .split('')
    .reverse()
    .join('');
}

export function isLoginTokenValid(token: string, email: string): boolean {
  return generateLoginToken(email) === token;
}
